var initializeSubmissionGalleryBlock = function(block){
	
	jQuery(document).on('opened', '.remodal', function(){
		
		var video = jQuery(".remodal-is-opened video");
		
		if(video.length) {
			video[0].play();
		}
		
	});
	
	jQuery(document).on('closing', '.remodal', function(){
		
		var video = jQuery(".remodal-is-opened video");
		
		if(video.length) {
			video[0].pause();
		}
		
	});

}

//initialize each block on front end
jQuery(document).ready(function(){
	jQuery('.wp-block-submission-gallery').each(function(){
		initializeSubmissionGalleryBlock(jQuery(this));
	});
});

//initialize dynamic block preview in the editor
if(window.acf)
	window.acf.addAction('render_block_preview/type=submission-gallery', initializeSubmissionGalleryBlock);
